const STYLES = {
  ORDER_CREATED: "bg-slate-100 text-slate-600",
  SHIPMENT_CREATED: "bg-slate-100 text-slate-600",
  AWB_ASSIGNED: "bg-blue-50 text-blue-700",
  LABEL_GENERATED: "bg-blue-50 text-blue-700",
  PICKUP_SCHEDULED: "bg-amber-50 text-amber-700",
  PICKED_UP: "bg-amber-100 text-amber-800",
  IN_TRANSIT: "bg-blue-100 text-blue-800",
  OUT_FOR_DELIVERY: "bg-violet-100 text-violet-700",
  DELIVERED: "bg-emerald-100 text-emerald-700",
  NDR: "bg-orange-100 text-orange-700",
  RTO: "bg-red-100 text-red-700",
  CANCELLED: "bg-slate-200 text-slate-500",
  EXCEPTION: "bg-red-100 text-red-700",
};

export default function StatusBadge({ status }) {
  const cls = STYLES[status] || "bg-slate-100 text-slate-600";
  return (
    <span data-testid={`status-badge-${(status || "").toLowerCase().replace(/_/g, "-")}`} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide ${cls}`}>
      {status?.replace(/_/g, " ")}
    </span>
  );
}
